import React, { useEffect,useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { AppContainer, MainContentContainer, BodyContainer, TableStyle,AdminTabs } from '../../resources/styling/appStyle';
import { SideMenu } from '../../components/layouts/SideMenu';
import { Header } from '../../components/layouts/Header';
import { Grid, Chip, Paper, InputBase,InputAdornment, IconButton,OutlinedInput, InputLabel, FormControl, Stack, MenuItem, Box, Select, Modal, TextField,Tabs,Tab} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { AppButton } from '../../resources/styling';
import { colors } from '../../resources/theme/colors';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  CircularProgress,
  Typography,
  TableSortLabel,
} from '@mui/material';

import schoolService from '../../services/api/schoolService';
import { toast } from 'react-toastify';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { connect } from 'react-redux';
import { welbeeDashboardLogo } from '../../resources/images/index';
import { superAdminActions } from '../../store/superAdminStore';
import { storageService } from '../../services';
import { routesObj } from '../../routes';
import { bindActionCreators } from 'redux';
import { limitAverageValue } from '../../utils/roundScore';
import { schoolListFlags, WebStorageNames } from '../../utils/Constants';
import { DateFormat } from '../../utils/CommonFunctions';
import { getDate } from 'date-fns';
import { isNull } from 'lodash';
import { borderRadius } from '@mui/system';
import { getAppUrls } from '../../utils/config';
import { Product, PRODUCT_DISPLAY_NAMES } from '../../utils/Constants';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  bgcolor: 'background.paper',
  borderRadius: 1,  
  boxShadow: 24,
  p: 3,
};

const { WELLBEING_APP_URL,INSIGHTS_APP_URL,HOME_APP_URL,EI_APP_URL } = getAppUrls();
const { mandy, pictonBlue } = colors;

const names = [
  { id: Product.MAIN_APP_TOOLKIT, name: PRODUCT_DISPLAY_NAMES[Product.MAIN_APP_TOOLKIT] },
  { id: Product.STUDENT_INSIGHT, name: PRODUCT_DISPLAY_NAMES[Product.STUDENT_INSIGHT] },
  { id: Product.PARENTS_INSIGHTS, name: PRODUCT_DISPLAY_NAMES[Product.PARENTS_INSIGHTS] },
  { id: Product.STAFF_INSIGHTS, name: PRODUCT_DISPLAY_NAMES[Product.STAFF_INSIGHTS] },
  { id: Product.EDU_INTELLIGENCE, name: PRODUCT_DISPLAY_NAMES[Product.EDU_INTELLIGENCE] },
  { id: Product.PULSE, name: PRODUCT_DISPLAY_NAMES[Product.PULSE] },
  { id: Product.EI_PRO, name: PRODUCT_DISPLAY_NAMES[Product.EI_PRO] },
  { id: Product.EI_ENTERPRISE, name: PRODUCT_DISPLAY_NAMES[Product.EI_ENTERPRISE] },
  { id: Product.SAFE_SPACE_CHECK_IN, name: PRODUCT_DISPLAY_NAMES[Product.SAFE_SPACE_CHECK_IN] },
];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 1 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const formatDate = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

function SchoolSubscriptionList() {

  
      const navigate = useHistory();
      const [sort, setSort] = React.useState('');
      const [value, setValue] = React.useState(0);
      const handleTabChange = (event, newValue) => {
        setValue(newValue);
      };
  
      const handleChange = (event) => {
          setSort(event.target.value);
      };
  
      const [open, setOpen] = React.useState(false);
      const handleOpen = () => setOpen(true);
      const handleClose = () => setOpen(false);
  
      
  
    const [adminDashboardInfo, setAdminDashboardInfo] = useState({});
    const [surveys, setSurveys] = React.useState([])
    const [mysurvey, setMysurvey] = React.useState([])
    const [filteredSurveys, setFilteredSurveys] = React.useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [addloading, setaddLoading] = useState(false);
    const [error, setError] = useState(null);
    const [order, setOrder] = useState('asc'); // 'asc' or 'desc'
    const [orderBy, setOrderBy] = useState('id'); // Default column to sort by
    const [searchQuery, setSearchQuery] = useState(''); // Search query state
    const [productName, setProductName] = React.useState([]);
    const [FileVal, setFile] = React.useState('');
    const [FileNameVal, setFileName] = React.useState('');
    const [TrancateFileName, setTrancateFileName] = React.useState('');
  
  
    useEffect(() => {
      setLoading(true)
      schoolService.getSchoolList(7)      
        .then((response) => {
          if (response.success) 
          {
            setAdminDashboardInfo(response);      
            console.log(response)    
            loadData();
            setLoading(false);          
          }
        })
        .catch(err => {})
        .finally(() => setLoading(false));
        const loadData = async () => {
          try {
            await new Promise((resolve) => setTimeout(resolve, 150000));        
          } catch (err) {       
          } finally {}
        };
              
    }, []);  
    
     const handleSchoolDetails = (id) => {
        // Handle edit action
        console.log('Edit item with ID:', id);
        Cookies.set('SchoolDetailId', id, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        navigate.push('/edit-subscription-school')
        // You can open a modal or navigate to an edit page here
      };
  
    const handleProductChange = (event) => {
      const {
        target: { value },
      } = event;
      setProductName(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );               
    };
  
    /* Welbee Grid Properties and function starts*/
    const handleDetails = (id) => {
      // Handle edit action
      console.log('Edit item with ID:', id);
      // You can open a modal or navigate to an edit page here
    };
  
    const handleDelete = (id) => {
      // Handle delete action
      console.log('Delete item with ID:', id);
      // Update the data state by removing the item
      //setData(data.filter((item) => item.id !== id));
    };
  
  
    const handleWelbeeChangePage = (event, newPage) => {
      setPage(newPage);
    };
    const handleWelbeeChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    const handleWelbeeSort = (property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    const handleSearch = (event) => {
      setSearchQuery(event.target.value); // Update search query
      setPage(0); // Reset to the first page when searching
    };
    
     // Filter data based on search query
    const filteredData = adminDashboardInfo.data?.filter(x => !x.IsTestAccount && !x.IsArchived && isNull(x.MatGroupId)).filter((row) =>
      Object.values(row).some(
        (value) =>
          typeof value === 'string' &&
          value.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  
    const sortedWelbeeData = (filteredData || []).slice().sort((a, b) => {
      if (a[orderBy] < b[orderBy]) {
        return order === 'asc' ? -1 : 1;
      }
      if (a[orderBy] > b[orderBy]) {
        return order === 'asc' ? 1 : -1;
      }
      return 0;
    });
  /* Welbee Grid Properties and function ends*/
  
  // Filter data based on search query
     const filteredTestData = adminDashboardInfo.data?.filter(x => x.IsTestAccount && !x.IsArchived && isNull(x.MatGroupId)).filter((row) =>
      Object.values(row).some(
        (value) =>
          typeof value === 'string' &&
          value.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  
    const sortedTestWelbeeData = (filteredTestData || []).slice().sort((a, b) => {
      if (a[orderBy] < b[orderBy]) {
        return order === 'asc' ? -1 : 1;
      }
      if (a[orderBy] > b[orderBy]) {
        return order === 'asc' ? 1 : -1;
      }
      return 0;
    });
  /* Welbee Grid Properties and function ends*/
  
  
  //New School Additional functons
   const [items, setItems] = useState([]);
   const [formData, setFormData] = useState({   
      establishmentName: '',
      numberofpupils: '',
      address3: '',
      urn: '',  
    });
    // Handle input changes
   
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value
      });
    };
    
    
    const addItem = () => {   
          
      if(formData.establishmentName =="")
      {    
        toast.error('Please enter School Name');
      }
      else if(formData.urn=="")
      {    
        toast.error('Please enter a School URN');
      }  
      else
      {
        setaddLoading(true);
        // Create new item object
        //debugger;
        const newItem = {
            Id: Date.now(), // Using timestamp as a simple unique ID
            Name: formData.establishmentName,
            NumberOfPupil: formData.numberofpupils === ""?0:formData.numberofpupils, // Convert string to number
            Address: formData.address3,
            WondeeSchoolUrn:formData.urn,
            File:  FileVal,
            FileName : FileNameVal,
            SchoolProducts:[],
          };            
          // Add to items array
          // setItems([...items, newItem]);
          if(newItem.establishmentName !== '' && newItem.urn !== '')
          {
            setItems([...items, newItem]);
            // Reset form
            const updateProds=productName.map(item=>
              item==='Main App & Toolkit'?'Main App and Toolkit':item
            );
            //add the add school logic here     
            newItem.SchoolProducts=updateProds;
          
            //schoolService.addNewIndividualSchool(newItem.EstablishmentName,newItem.Address3,newItem.URN,newItem.NumberOfPupils,updateProds).then((response) => {
  
            schoolService.addNewIndividualSchoolPost(newItem).then((response) => {
              const { success, message } = response;      
              if (success) 
              {
                // User Story 1.3: Generate invoice for subscription if school was created with subscription data
                // Note: Schools created from SchoolSubscriptionList typically don't have subscription data in newItem
                // Invoice generation will be handled when subscription is created/updated for the group
                if (response.data) {
                  // Extract school ID from response
                  const schoolId = response.data?.Id || response.data?.data?.Id || response.data?.id;
                  if (schoolId) {
                    console.log('School created successfully with ID:', schoolId);
                    // Invoice generation will be handled separately when subscription is created
                  }
                }
                
                  toast.success('School added successfully');
                  // Reset form
                  setFormData({
                    establishmentName: '',
                    numberofpupils: '',
                    address3: '',
                    urn: ''
                  });
                  setProductName([]);
                  setaddLoading(false);
              }
              else 
              {
                  toast.error(message);
              }
            });
          }
          else{
              if(newItem.establishmentName == '')
              {
                toast.error('Please enter School Name');
              }
              else if(newItem.urn == '')
            {
                toast.error('Please enter School URN');
            }
          }
          // alert('school save called');
          // debugger;
         
        }
         
    };
  
    const removeItem = (idToRemove) => {
      setItems(items.filter(item => item.id !== idToRemove));
    };
  
    const updateItem = (idToUpdate, updatedProperties) => {
      setItems(items.map(item => 
        item.id === idToUpdate ? { ...item, ...updatedProperties } : item
      ));
    };
   //New School Additional functons
  
    if (error) {
      return (
        <Typography variant="h6" color="error" align="center">
          {error}
        </Typography>
      );
    }
  
   
      const handleEDUIntellSchoolclick = (MATId,SchoolId) => {
        Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days    
        Cookies.set('MatToken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
        Cookies.set('schooltoken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
        Cookies.remove('MatToken');
        Cookies.remove('schooltoken');     
        Cookies.remove('Type');
        Cookies.remove('MATId');
        Cookies.remove('SchoolId');       
        Cookies.set('Type', 'School', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
        Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
        Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
        var SchoolURL=EI_APP_URL; //"https://ei.welbee.co.uk/login";
        window.open(SchoolURL);
      };
    
      const handleSchoolInsightsclick = (MATId,SchoolId) => {
        Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days       
        Cookies.set('MatToken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
        Cookies.set('schooltoken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
        Cookies.remove('MatToken');
        Cookies.remove('schooltoken');     
        Cookies.remove('Type');
        Cookies.remove('MATId');
        Cookies.remove('SchoolId');       
        Cookies.set('Type', 'School', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
        Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
        Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
        var SchoolURL=INSIGHTS_APP_URL; //"https://insights.welbee.co.uk/login";
        window.open(SchoolURL);
      };       
    
      const handleSchoolWelbeingclick = (MATId,SchoolId) => {
        Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days   
        Cookies.set('RaisedFrom', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
        Cookies.set('MatToken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days      
        Cookies.remove('MatToken');
        Cookies.remove('schooltoken');     
        Cookies.remove('Type');
        Cookies.remove('MATId');
        Cookies.remove('SchoolId');       
        Cookies.set('Type', 'School', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
        Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
        Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days   
        var SchoolURL=WELLBEING_APP_URL; //"https://s.wellbeing.welbee.co.uk/login";
        window.open(SchoolURL);   
      };    
    
      const handleSchoolHomeclick = (MATId,SchoolId) => {
        Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        Cookies.set('MatToken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
        Cookies.set('schooltoken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
        Cookies.remove('MatToken');
        Cookies.remove('schooltoken');     
        Cookies.remove('Type');
        Cookies.remove('MATId');
        Cookies.remove('SchoolId');         
        Cookies.set('Type', 'School', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
        Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
        Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
        // var SchoolURL="https://s.peoplemanagement.welbee.co.uk/login";
        var SchoolURL=HOME_APP_URL; //"https://s.home.welbee.co.uk/login";
        window.open(SchoolURL);    
      };
        

  return (
    <AppContainer>                                 
         <AdminTabs style={{ marginTop: '20px' }}>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                aria-label='admin-tabs'
              >
                <Tab label='Live Schools' />
                <Tab label='Test Schools' />
              </Tabs>
            </Box>
            {loading===true? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                <CircularProgress />
                </div>  
            ) : (
            <div>
              <CustomTabPanel value={value} index={0}>
                <Grid container mt={2}>
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                      <TableStyle>                            
                          <Paper elevation={0}>
                              <TableContainer>
                                  <Table>
                                  <TableHead>
                                      <TableRow>
                                      <TableCell>
                                          <TableSortLabel
                                          active={orderBy === 'Name'}
                                          direction={orderBy === 'Name' ? order : 'asc'}
                                          onClick={() => handleWelbeeSort('Name')}
                                          >
                                          School Name
                                      </TableSortLabel>
                                      </TableCell>                                     
                                      <TableCell>
                                      <TableSortLabel
                                          active={orderBy === 'Products'}
                                          direction={orderBy === 'Products' ? order : 'asc'}
                                          onClick={() => handleWelbeeSort('Products')}
                                          >
                                          Products
                                      </TableSortLabel>
                                      </TableCell>
                                      <TableCell>Start Date</TableCell>
                                      <TableCell>End Date</TableCell>
                                      <TableCell>Subscription Cost</TableCell>                                                                                             
                                      <TableCell>
                                        Action
                                    </TableCell>
                                      </TableRow>
                                  </TableHead>                          
                                  <TableBody>
                                      {(sortedWelbeeData || [])
                                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                      .map((row) => (
                                      <TableRow key={row.Id}>
                                          <TableCell>{row.Name}</TableCell>                                          
                                          <TableCell>
                                              <Stack direction="row" flexWrap="wrap" rowGap={0.5} columnGap={0.5}>
                                                {row.schoolProductsList && row.schoolProductsList.length > 0 ? (
                                                    row.schoolProductsList.filter((item, index, self) => 
                                                      self.findIndex((i) => i.Product === item.Product) === index
                                                    ).map((schoolProds) => (
                                                        <React.Fragment key={schoolProds.id}>                                                                      
                                                        {schoolProds.Product === 1 && (
                                                            // <Chip label="Main App & Toolkit" className='staff-chip' size='small'/>
                                                            <AppButton  label="Main App & Toolkit" onClick={() => handleSchoolWelbeingclick(schoolProds.MatId,schoolProds.SchoolId)} className='staff-chip' size='small'>Main App & Toolkit</AppButton>
                                                        )}
                                                        {schoolProds.Product === 2 && (
                                                            // <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                            <AppButton  label="Student Insight" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='parent-chip' size='small'>Student Insight</AppButton>
                                                        )}
                                                        {schoolProds.Product === 3 && (
                                                            // <Chip label="Parents Insights" className='insight-chip' size='small'/>
                                                            <AppButton  label="Parents Insights" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='insight-chip' size='small'>Parents Insights</AppButton>
                                                        )}
                                                        {schoolProds.Product === 4 && (
                                                            // <Chip label="Staff Insights" className='student-chip' size='small'/>
                                                            <AppButton  label="Staff Insights" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='student-chip' size='small'>Staff Insights</AppButton>
                                                        )}
                                                        {schoolProds.Product === 5 && (
                                                            // <Chip label="Edu Intelligence" className='learning-chip' size='small'/>
                                                            <AppButton  label="Edu Intelligence" onClick={() => handleEDUIntellSchoolclick(schoolProds.MatId,schoolProds.SchoolId)} className='edu-chip' size='small'>Edu Intelligence</AppButton>
                                                        )}
                                                        {schoolProds.Product === 6 && (
                                                            <AppButton  label="Pulse"  className='lparent-chip' size='small'>Pulse</AppButton>
                                                        )}
                                                        </React.Fragment>
                                                    ))
                                                ) : (
                                                    <Chip label="No products available." className='learning-chip' size='small'/>                                                                      
                                                )}
                                                  {/* <Chip label="Staff Wellbeing" className='staff-chip' size='small'/>
                                                  <Chip label="Staff Insight" className='student-chip' size='small'/>
                                                  <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                  <Chip label="Parent Insight" className='insight-chip' size='small'/> */}
                                              </Stack>
                                          </TableCell>                                    
                                          <TableCell>{row.SchoolSubscription==null?'--':formatDate(row.SchoolSubscription.StartDate)}</TableCell>
                                          <TableCell>{row.SchoolSubscription==null?'--':formatDate(row.SchoolSubscription.EndDate)}</TableCell>                                                                    
                                          <TableCell>£{(parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year1Cost) + parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year2Cost) + 
                                          parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year3Cost))+((parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year1Cost) + 
                                          parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year2Cost) + parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year3Cost))*
                                          (parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.VatPercentApplied)/100))}</TableCell>
                                          <TableCell>
                                          <Stack direction="row" spacing={0.5}>                                                                                                                                                        
                                              <AppButton onClick={() => handleSchoolDetails(row.Id)} color={pictonBlue}>Renew</AppButton>                                                                                                                            
                                          </Stack>
                                          </TableCell>                                   
                                      </TableRow>
                                      ))}
                                  </TableBody>
                                  </Table>
                              </TableContainer>
                              <TablePagination
                                  rowsPerPageOptions={[10, 20, 30]}
                                  component="div"
                                  count={filteredData.length}
                                  rowsPerPage={rowsPerPage}
                                  page={page}
                                  onPageChange={handleWelbeeChangePage}
                                  onRowsPerPageChange={handleWelbeeChangeRowsPerPage}
                              />
                          </Paper>  
                      </TableStyle> 
                  </Grid>
                </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <Grid container mt={2}>
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                      <TableStyle>                            
                          <Paper elevation={0}>
                              <TableContainer>
                                  <Table>
                                  <TableHead>
                                      <TableRow>
                                      <TableCell>
                                          <TableSortLabel
                                          active={orderBy === 'Name'}
                                          direction={orderBy === 'Name' ? order : 'asc'}
                                          onClick={() => handleWelbeeSort('Name')}
                                          >
                                          School Name
                                      </TableSortLabel>
                                      </TableCell>                                     
                                      <TableCell>
                                      <TableSortLabel
                                          active={orderBy === 'Products'}
                                          direction={orderBy === 'Products' ? order : 'asc'}
                                          onClick={() => handleWelbeeSort('Products')}
                                          >
                                          Products
                                      </TableSortLabel>
                                      </TableCell>
                                      <TableCell>Start Date</TableCell>
                                      <TableCell>End Date</TableCell>
                                      <TableCell>Subscription Cost</TableCell>                                                                                             
                                      <TableCell>
                                        Action
                                    </TableCell>
                                      </TableRow>
                                  </TableHead>                       
                                  <TableBody>
                                      {(sortedTestWelbeeData || [])
                                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                      .map((row) => (
                                        <TableRow key={row.Id}>
                                        <TableCell>{row.Name}</TableCell>                                          
                                        <TableCell>
                                            <Stack direction="row" flexWrap="wrap" rowGap={0.5} columnGap={0.5}>
                                              {row.schoolProductsList && row.schoolProductsList.length > 0 ? (
                                                  row.schoolProductsList.filter((item, index, self) => 
                                                    self.findIndex((i) => i.Product === item.Product) === index
                                                  ).map((schoolProds) => (
                                                      <React.Fragment key={schoolProds.id}>                                                                      
                                                      {schoolProds.Product === 1 && (
                                                          // <Chip label="Main App & Toolkit" className='staff-chip' size='small'/>
                                                          <AppButton  label="Main App & Toolkit" onClick={() => handleSchoolWelbeingclick(schoolProds.MatId,schoolProds.SchoolId)} className='staff-chip' size='small'>Main App & Toolkit</AppButton>
                                                      )}
                                                      {schoolProds.Product === 2 && (
                                                          // <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                          <AppButton  label="Student Insight" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='parent-chip' size='small'>Student Insight</AppButton>
                                                      )}
                                                      {schoolProds.Product === 3 && (
                                                          // <Chip label="Parents Insights" className='insight-chip' size='small'/>
                                                          <AppButton  label="Parents Insights" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='insight-chip' size='small'>Parents Insights</AppButton>
                                                      )}
                                                      {schoolProds.Product === 4 && (
                                                          // <Chip label="Staff Insights" className='student-chip' size='small'/>
                                                          <AppButton  label="Staff Insights" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='student-chip' size='small'>Staff Insights</AppButton>
                                                      )}
                                                      {schoolProds.Product === 5 && (
                                                          // <Chip label="Edu Intelligence" className='learning-chip' size='small'/>
                                                          <AppButton  label="Edu Intelligence" onClick={() => handleEDUIntellSchoolclick(schoolProds.MatId,schoolProds.SchoolId)} className='edu-chip' size='small'>Edu Intelligence</AppButton>
                                                      )}
                                                      {schoolProds.Product === 6 && (
                                                          <AppButton  label="Pulse"  className='lparent-chip' size='small'>Pulse</AppButton>
                                                      )}
                                                      </React.Fragment>
                                                  ))
                                              ) : (
                                                  <Chip label="No products available." className='learning-chip' size='small'/>                                                                      
                                              )}
                                                {/* <Chip label="Staff Wellbeing" className='staff-chip' size='small'/>
                                                <Chip label="Staff Insight" className='student-chip' size='small'/>
                                                <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                <Chip label="Parent Insight" className='insight-chip' size='small'/> */}
                                            </Stack>
                                        </TableCell>                                    
                                        <TableCell>{row.SchoolSubscription==null?'--':formatDate(row.SchoolSubscription.StartDate)}</TableCell>
                                        <TableCell>{row.SchoolSubscription==null?'--':formatDate(row.SchoolSubscription.EndDate)}</TableCell>                                                                    
                                        <TableCell>£{(parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year1Cost) + parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year2Cost) + 
                                        parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year3Cost))+((parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year1Cost) + 
                                        parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year2Cost) + parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.Year3Cost))*
                                        (parseInt(row.SchoolSubscription==null?0:row.SchoolSubscription.VatPercentApplied)/100))}</TableCell>
                                        <TableCell>
                                        <Stack direction="row" spacing={0.5}>                                                                                                                                                        
                                            <AppButton onClick={() => handleSchoolDetails(row.Id)} color={pictonBlue}>Renew</AppButton>                                                                                                                            
                                        </Stack>
                                        </TableCell>                                   
                                    </TableRow>
                                      ))}
                                  </TableBody>
                                  </Table>
                              </TableContainer>
                              <TablePagination
                                  rowsPerPageOptions={[10, 20, 30]}
                                  component="div"
                                  count={filteredTestData.length}
                                  rowsPerPage={rowsPerPage}
                                  page={page}
                                  onPageChange={handleWelbeeChangePage}
                                  onRowsPerPageChange={handleWelbeeChangeRowsPerPage}
                              />
                          </Paper>  
                      </TableStyle> 
                  </Grid>
                </Grid>
              </CustomTabPanel>                       
            </div>
            )}
          </Box>
         </AdminTabs>         
    </AppContainer>    
  );
}

// export default withRouter(SchoolSubscriptionList);
export { SchoolSubscriptionList };